import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import {
  getGraphIssuesSummary,
  getIssuesPanelOpen,
  setIssuesPanelOpen,
} from "../state/graphuSlice";

// Module-level ⚠ pill next to the project title: the problems it counts span
// the whole scenario (canvas nodes, translations AND the unlinked-scenes
// strip), so it lives above the graph, not in the canvas toolbar. Same pill
// as the publication cards' badge. Renders nothing while no graph is mounted
// (summary is null outside the Scénario tab).
const GraphIssuesBadge = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const summary = useAppSelector(getGraphIssuesSummary);
  const issuesOpen = useAppSelector(getIssuesPanelOpen);

  if (!summary) return null;
  const total = summary.errorCount + summary.warningCount + summary.unlinkedCount;
  if (total === 0) return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(setIssuesPanelOpen(!issuesOpen))}
      className={`ml-2 flex items-center gap-1 px-2 py-1 border rounded-lg text-sm bg-white font-medium transition-colors ${
        summary.errorCount > 0 ? "border-red-400 text-red-600" : "border-amber-400 text-amber-600"
      }`}
      title={t("pages.project.edit.graphIssuesTitle")}
    >
      <span>⚠</span>
      <span>{total}</span>
      {/* Single glyph flipped in CSS: ◂ and ▸ are different codepoints with
          different font fallbacks, so toggling glyphs makes the caret jump. */}
      <span className={`inline-block text-xs ${issuesOpen ? "" : "rotate-180"}`}>▸</span>
    </button>
  );
};

export default GraphIssuesBadge;
